export default __webpack_public_path__ + "static/media/Ballroll_00332.587b8767.png";